/*
 CustomPanel

pobierane z serwera + fabryka komponentów - do zrobienia
 
*/
import * as React from 'react';

import { connect } from 'react-redux';

import { AppState, /*Actions, store,*/ }
  from '../../appredux';

import { Trans, WithTranslation, withTranslation } from 'react-i18next';

import MailIcon from '@material-ui/icons/Mail'
import CallIcon from '@material-ui/icons/Call'
//import PrintIcon from '@material-ui/icons/Print'
import HomeIcon from '@material-ui/icons/Home'
import GpsIcon from '@material-ui/icons/GpsFixed'

import { Typography, TableRow } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import { Paper } from '@material-ui/core';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";

import { Info } from '../../api';

//import theme  from '../themes';

interface CustomPanelProps {
  contact: Info
}

class CustomPanel extends React.Component<CustomPanelProps & WithTranslation & WithStyles<typeof styles>, any>  {

  /*      
    async getPanelData() {
      console.log('Pobieram Panel')
  // zob. http://yarpo.pl/2018/03/26/promise-w-typescript-rozwiazywanie-asynchronicznych-funkcji/
      portalService.recepcjaDajWwwPortalInfo(
          {   
            aOperatorId: 99,
            aDomena: ''
            }, {})
          .then(
              (res : IWebDescription) => { 
                  this.setState({...this.state,
                      panel : res.info,
                      ready : true});
                  store.dispatch(
                          Actions.pageState.setContact(
                              {
                                  email: res.kontakt_e_mail,
                                  phone : res.kontakt_telefon,
                                  fax: res.kontakt_fax,
                                  address: res.kontakt_adres,
                                  gps: res.kontakt_gps                                 
                              }
                          )
                    );
              }
          ).catch( console.error  );
      
      }
  */

  render() {
    const { classes } = this.props;

    if (this.props.contact.info)
      return (
        // paddingBottom: "10px"
        <div style={{ fontFamily: 'sans-serif',  }}>
          {/*<Typography gutterBottom component="h6" 
                          className={`${classes.blue} ${classes.headline}`} 
                          style={{padding: "5px"}}>
                <Trans >Hotel info</Trans>         
          </Typography>
              <hr/>*/}
          <div dangerouslySetInnerHTML={{ __html: this.props.contact.info }} style={{ padding: "10px 20px" }}
            className={classes.text} />
        </div>
      )
    else
      return (<div></div>)
  }
}

type ContactPanelProps = {
  contact: Info,
}

class ContactPanelC extends React.Component<ContactPanelProps & WithTranslation & WithStyles<typeof styles>, any> {

  //PM 2021-07-05
  render() {
    const { classes } = this.props;
    let emailHref = 'mailto:' + this.props.contact.kontaktEmail
    //const classes = styles(theme); //useStyles();

    /*return(
     <div className={ classes.contact }>
       <div className={ classes.paper }>
         <Typography gutterBottom  variant="h5" component="h2" className={classes.blue} style={{ padding: "5px"}}>
            <Trans >Contact</Trans>         
         </Typography>
         <hr/>
         <ul className={classes.list} >
             <li className={classes.row} >
                 <Typography variant="body2" >
                 <MailIcon className={classes.icon} />
                 <span  className={classes.title} >
                 <Trans>email</Trans>: 
                 </span>
                 <strong>
                 <span  className={classes.info} >
                 <a href={ emailHref } style={{color: "inherit", textDecoration: "none"}}>
                 { props.page.contact.email }
                 </a>
                 </span>
                 </strong>
                 </Typography>
             </li>
             <li className={classes.row} >
                 <Typography variant="body2">
                 <CallIcon className={classes.icon} />
                 <span  className={classes.title} >
                 <Trans>Phone</Trans>:
                 </span>
                 <strong>
                 <span  className={classes.info}>
                 { props.page.contact.phone }
                 </span>
                 </strong>
                 </Typography>
             </li>
             <li className={classes.row} >
                 <Typography variant="body2">
                 <PrintIcon className={classes.icon} />
                 <span  className={classes.title} >
                 <Trans>fax</Trans>: 
                 </span>
                 <strong>
                 <span  className={classes.info}>
                 { props.page.contact.fax }
                 </span>
                 </strong>
                 </Typography>
             </li>
             <li className={classes.row} >
                <Typography variant="body2">
                <GpsIcon className={classes.icon} />
                <span  className={classes.title} >
                <Trans>GPS</Trans>:
                </span>
                <strong>
                <span  className={classes.info}>
                 { props.page.contact.gps }
                 </span>
                 </strong>
                 </Typography>
             </li>
             <li className={classes.row} >
                 <Typography variant="body2">
                 <HomeIcon className={classes.icon} />
                 <span  className={classes.title} >
                 <Trans>Address</Trans>: 
                 </span>
                 <strong>
                 <span  className={classes.info}>
                 { props.page.contact.address }
                 </span>
                 </strong>
                 </Typography>
             </li>   
         </ul>
       </div>
    </div>);
  }*/

    return (
      <div className={classes.contact}>
        <Paper className={classes.paper} elevation={4} style={{ marginTop: "10px", padding: "0px", paddingLeft: "14px" }}>
          <Typography gutterBottom component="h6" style={{
            margin: "0px",
            padding: "9px 14px 9px 0"
          }}
            className={classes.headline}
            color='secondary'
          >
            <Trans >Contact</Trans>
          </Typography>
        </Paper>
        <Paper /*className={"Paper"}*/ elevation={4} classes={{ root: classes.paper }}>
          <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
            <Table className={classes.table}>
              <TableBody>
                <TableRow className={classes.row} >
                  <TableCell align="left" style={{ width: "90px" }}
                    className={classes.cell}>
                    <Typography className={classes.body}>
                      <MailIcon className={`${classes.icon} ${classes.body}`} />
                      <span className={classes.title} >
                        <Trans>email</Trans>:
                      </span>
                    </Typography>
                  </TableCell>
                  <TableCell align="right" className={classes.cell}>
                    <Typography className={classes.body} color='secondary'>
                      <a href={emailHref} style={{ color: "inherit", textDecoration: "none" }}>
                        {this.props.contact.kontaktEmail}
                      </a>
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow className={classes.row} >
                  <TableCell align="left" style={{ width: "90px" }}
                    className={classes.cell}>
                    <Typography className={classes.body}>
                      <CallIcon className={`${classes.icon} ${classes.body}`} />
                      <span className={classes.title} >
                        <Trans>Phone</Trans>:
                      </span>
                    </Typography>
                  </TableCell>
                  <TableCell align="right" className={classes.cell}>
                    <Typography className={classes.body} color='secondary'>
                      {this.props.contact.kontaktTelefon}
                    </Typography>
                  </TableCell>
                </TableRow>
                {/*<TableRow className={classes.row} >
              <TableCell align="left" style={{width: "90px"}}
                        className={classes.cell}>
                  <Typography className={classes.body}>
                  <PrintIcon className={`${classes.icon} ${classes.body}`} />
                  <span  className={classes.title} >
                  <Trans>fax</Trans>: 
                  </span>
                  </Typography>
                </TableCell>
                <TableCell align="right" className={classes.cell}>
                  <Typography className={`${classes.info} ${classes.body}`}> 
                  { props.page.contact.fax }
                  </Typography>
              </TableCell>  
            </TableRow>*/}
                <TableRow className={classes.row} >
                  <TableCell align="left" style={{ width: "90px" }}
                    className={classes.cell}>
                    <Typography className={classes.body}>
                      <GpsIcon className={`${classes.icon} ${classes.body}`} />
                      <span className={classes.title} >
                        <Trans>GPS</Trans>:
                      </span>
                    </Typography>
                  </TableCell>
                  <TableCell align="right" className={classes.cell}>
                    <Typography className={classes.body} color='secondary'>
                      {this.props.contact.kontaktGps}
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow className={classes.row} >
                  <TableCell align="left" style={{ width: "90px" }}
                    className={classes.cell}>
                    <Typography className={classes.body}>
                      <HomeIcon className={`${classes.icon} ${classes.body}`} />
                      <span className={classes.title} >
                        <Trans>Address</Trans>:
                      </span>
                    </Typography>
                  </TableCell>
                  <TableCell align="right" className={classes.cell}>
                    <Typography className={classes.body} color='secondary'>
                      {this.props.contact.kontaktAdres}
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </div>
        </Paper>
      </div>);
  }
}

const styles = (theme: Theme) => ({
  contact: {
  },
  title: {
    marginBottom: "0.3em",
    marginLeft: "1em",
    marginRight: "1em",
    width: '100%'
  },
  info: {
    marginBottom: "0.3em",
    justifyContent: "flex-end",
    width: "100%",
    color: "#3a87ad"
  },
  row: {
    padding: "7px 0px"
  },
  icon: {
    backgroundColor: theme.palette.background.default
  },
  /*list: {
    color: theme.palette.primary.dark,
    listStyleType: "none",
    width: "100%",
    paddingInlineStart: "20px"
  },*/
  paper: {
    padding: "0.4em",
    background: "linear-gradient(to bottom, #ffffff, #f7f7f7)",
    marginBottom: "1em"
    //backgroundColor : theme.palette.background.default
    //padding: "0px",    
  },
  text: {
    color: theme.palette.text.primary
  },
  body: {
    fontSize: "12px",
    fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "20px",
    fontWeight: theme.typography.body2.fontWeight
  },
  headline: {
    fontFamily: "\"'Open Sans'\", sans-serif",
    lineHeight: "20px",
    fontSize: "14px",
    fontWeight: 600
  },
  table: {
    paddingLeft: "30px"
  },
  cell: {
    padding: "7px 5px 7px 16px"
  }
});


const mapStateToProps = (state: AppState) => ({
  contact: state.pageState.contact
});

export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(CustomPanel)));

export const ContactPanel = connect(mapStateToProps)(withStyles(styles)(withTranslation()(ContactPanelC)));
